"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_TAGS = exports.Tag = void 0;
var Tag;
(function (Tag) {
    Tag["BUILDING"] = "building";
    Tag["SPACE"] = "space";
    Tag["SCIENCE"] = "science";
    Tag["POWER"] = "power";
    Tag["EARTH"] = "earth";
    Tag["JOVIAN"] = "jovian";
    Tag["VENUS"] = "venus";
    Tag["PLANT"] = "plant";
    Tag["MICROBE"] = "microbe";
    Tag["ANIMAL"] = "animal";
    Tag["CITY"] = "city";
    Tag["MOON"] = "moon";
    Tag["MARS"] = "mars";
    Tag["CRIME"] = "crime";
    Tag["WILD"] = "wild";
    Tag["EVENT"] = "event";
    Tag["CLONE"] = "clone";
})(Tag || (exports.Tag = Tag = {}));
exports.ALL_TAGS = [
    Tag.BUILDING,
    Tag.SPACE,
    Tag.SCIENCE,
    Tag.POWER,
    Tag.EARTH,
    Tag.JOVIAN,
    Tag.VENUS,
    Tag.MOON,
    Tag.MARS,
    Tag.PLANT,
    Tag.MICROBE,
    Tag.ANIMAL,
    Tag.CRIME,
    Tag.CITY,
    Tag.WILD,
    Tag.EVENT,
    Tag.CLONE,
];
